import classNames from 'classnames'
import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IAssetOption } from '~/types/option'
import type { IPlaceholderRule } from '~/types/template'

import Tooltip from '~/components/Tooltip'
import { getAssetErrors } from '~/utils/page-container'

interface Props {
  asset: IAssetOption
  className?: string
  rules?: IPlaceholderRule[]
}

const WarningTooltip = ({ asset, className, rules }: Props): ReactElement | null => {
  const errors = getAssetErrors({ asset, rules })

  const iconClassnames = classNames('warning-tooltip-component', className)

  if (!errors) {
    return null
  }

  const warningMessage =
    errors.qualityIdentifiers.length > 0
      ? `Quality identifiers missing: ${errors.qualityIdentifiers.join(', ')}.`
      : null

  return warningMessage ? (
    <Tooltip
      align={{ points: ['bl', 'tl'] }}
      mouseEnterDelay={0.2}
      overlay={warningMessage}
      placement="topRight"
      trigger={['hover']}
    >
      <div className={iconClassnames}>
        <MdInfoOutline color="#ca3423" size={16} />
      </div>
    </Tooltip>
  ) : null
}

export default WarningTooltip
